document.addEventListener("DOMContentLoaded",()=>{

const section=document.querySelector(".tec-cta");
const btn=document.querySelector(".tec-cta__btn");

if(!section) return;

/* animacion entrada */

section.style.opacity="0";
section.style.transform="translateY(40px)";
section.style.transition="all .9s ease";

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

section.style.opacity="1";
section.style.transform="translateY(0)";

}

});

},{threshold:.35});

observer.observe(section);

/* micro pulso boton */

if(btn){

setInterval(()=>{

btn.style.transform="scale(1.05)";

setTimeout(()=>{

btn.style.transform="scale(1)";

},500);

},4000);

}

});